//	@flow


export const SET_IFRAME_PATH = 'SET_IFRAME_PATH';
